export class EventBasicData {
	public begin: string;
	public end: string;
	public merchantId: string;
	public storageId: number;
	public title: string;
	public subtitle: string;
	public uuid: string;
	public seasonEvent: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/event-basic-data.model.ts